import { DTO__generation } from '@shared/dto/generation/DTO__generation';
import { DTO_TREE__generations_sliding_window } from '@shared/dto/generation/tree/DTO_TREE__generations_sliding_window';
import { G_HEADER__generations_history_item } from './G_HEADER__generations_history_item';

interface PROPS {
  items: DTO__generation[];
  sliding_window: DTO_TREE__generations_sliding_window;
  is_bar_hovered: boolean;
}

export function G_HEADER__generations_history_column({ items, sliding_window, is_bar_hovered }: PROPS) {
  /*
   * STORE
   */

  /*
   * STATE
   */

  /*
   * EFFECTS
   */

  /*
   * METHODS
   */

  /*
   * RENDERS
   */

  function render_items() {
    return items.map(generation => {
      let is_active = sliding_window.is_part_of_path(generation._id);

      return (
        <div key={generation._id} data-active={is_active}>
          <G_HEADER__generations_history_item key={generation._id} {...{ generation, sliding_window }} is_bar_hovered={is_bar_hovered} />
        </div>
      );
    });
  }

  /*
   * HTML
   */
  if (items.length === 0) return null;

  return <div className="flex flex-col gap-0 shrink-0  overflow-y-auto w-32 max-h-full h-full">{render_items()}</div>;
}
